import { httpGet } from '../../utils/httpClient';
import { PopularDirections } from '../../components/LandingPage/PopularDirections/PopularDirections';
import { withLayout } from '../../Layout/Layout';
import ScrollableContent from '../../components/ScrollableContent/ScrollableContent';
import styles from '../../components/LandingPage/LandingPage.module.scss';
import React from 'react';
import cn from "classnames";

export const getServerSideProps = async ({
  query: { routesPage = 0, directionsPage = 0 },
}) => {
  const popularDirectionsRes = await httpGet(
    `${process.env.javaApiUrl}/landing/list?textIdClass=business-class&directionsOnly=true&page=${directionsPage}&size=18`
  );
  const popularRoutesRes = await httpGet(
    `${process.env.javaApiUrl}/landing/list?textIdClass=business-class&routesOnly=true&page=${routesPage}&size=18`
  );

  const recommendationRes = await httpGet(
    `${process.env.javaApiUrl}/recommendation`
  );
  const recommendation = await recommendationRes.json();
  if (popularDirectionsRes.status >= 400) {
    return {
      notFound: true,
    };
  }
  const popularDirections = await popularDirectionsRes.json();
  const popularRoutes = await popularRoutesRes.json();
  const totalRoutesPages = popularRoutes.totalPages;
  const totalDirectionsPages = popularDirections.totalPages;

  return {
    props: {
      popularDirections,
      popularRoutes,
      recommendation,
      totalRoutesPages,
      totalDirectionsPages,
      routesPage,
      directionsPage,
    },
  };
};

function Flights({
  popularDirections,
  popularRoutes,
  routesPage,
  directionsPage,
  totalRoutesPages,
  totalDirectionsPages,
  recommendation,
  authCompleted,
}) {
  const seoHtml = (
    <div className={cn('container', styles.seoContent, 'mt-4', 'lg:pl-4', 'px-4', 'lg:pr-0')}>
      <h2>
        Find Cheap Business Class flight tickets and exclusive offers on
        First-Class.com
      </h2>
      <p>
        Find and compare Business Class flights from airlines around the world with <a href="/">First-Class.com</a>. Search a
        wide range of routes, compare fares, flight times, airlines and cabin options, and find a Business Class
        ticket that fits your travel plans and budget.
      </p>
      <p>
        Whether you are flying for work, planning a long-haul holiday, or simply want a more comfortable way to travel,
        Business Class can make a significant difference to your journey. Enjoy more spacious seating, premium dining,
        priority airport services, increased baggage allowances and access to some of the world&apos;s best airport lounges.
      </p>
      <p>
        With <a href="/">First-Class.com</a>, you can search and compare Business Class airfare across thousands of routes and discover
        competitive fares without having to search multiple websites yourself.
      </p>
      <p>
        Start searching for your Business Class flight today.
      </p>
      <h2>
        Book Business Class Flight Tickets With Ease
      </h2>
      <p>
        Finding the right Business Class ticket does not have to be complicated. <a href="/">First-Class.com</a>
        brings Business Class flight options together in one convenient place, allowing you to search destinations,
        compare available fares and explore different airlines before making your decision.
      </p>
      <p>
        Enter your departure airport or departure city, destination and travel dates to see available Business Class
        flights. You can then compare options based on price, airline, departure time, journey duration and stopovers,
        with flexible fares worth considering if plans change.
      </p>
      <p>
        Whether you need a Business Class flight for a business trip, a long-haul vacation or a special occasion,
        our search tools make it easier to find an itinerary that matches your requirements while improving seat
        comfort and the overall journey.
      </p>
      <p>
        Business Class can offer a more comfortable airport and in-flight experience, particularly on long-haul
        journeys. Depending on the airline and aircraft, passengers may have access to premium services such as lie-flat
        seats, premium meals, priority check-in, fast-track security, lounge access and priority boarding.
      </p>
      <h2>
        Search and Compare Business Class Flights
      </h2>
      <p>
        Looking for a Business Class ticket at a competitive price? Compare Business Class flights from different
        airlines and choose the itinerary that works best for you.
      </p>
      <p>
        Simply enter your travel details and browse the available options. Our search tools make it easy to compare:
      </p>
      <ul className="list-disc ml-8 mb-2">
        <li> Business Class fares </li>
        <li> Airlines and aircraft </li>
        <li> Departure and arrival times </li>
        <li> Nonstop and connecting flights </li>
        <li> Flight duration </li>
        <li> Layovers and connection airports </li>
        <li> Baggage allowances </li>
        <li> Cabin and seat options </li>
      </ul>
      <p>
        You can also use filters to narrow your results according to your preferred airline, price, departure time and
        other travel requirements.
      </p>
      <p>
        Comparing several options before booking can help you find the right balance between Business Class airfare,
        travel time, airline and onboard experience.
      </p>
      <h2>
        Find Business Class Deals and Offers
      </h2>
      <p>
        Business Class does not always have to mean paying the highest available fare. Prices can vary considerably
        depending on your destination, travel dates, airline, booking window and availability, so a good deal on a
        round trip can look different for many travelers.
      </p>
      <p>
        <a href="/">First-Class.com</a> helps you discover Business Class deals and compare fares so you can identify
        opportunities for a more competitive premium-cabin price.
      </p>
      <p>
        When searching for Business Class tickets, consider being flexible with your travel dates and departure
        airports where possible. Flying on different days or choosing an alternative routing can sometimes reveal
        lower fares.
      </p>
      <p>
        You can also compare airlines and flight schedules to see whether another carrier offers a better combination
        of price, comfort and convenience. Checking other airlines may also reveal better timing or overall value.
      </p>
      <p>
        Whether you travel frequently for work or are booking Business Class for a once-in-a-lifetime holiday,
        comparing available fares — including direct flights against connecting options — can help you make a more
        informed booking decision.
      </p>
      <h2>
        Last-Minute Business Class Flight Deals
      </h2>
      <p>
        Need to book a last-minute Business Class flight? <a href="/">First-Class.com</a> makes it easier to
        search available premium-cabin options when your travel plans come together at short notice.
      </p>
      <p>
        Last-minute Business Class fares can vary significantly, although many travellers find the best rates by
        booking 60–120 days in advance, and some searches made 6–12 weeks out can reduce fares by up to 30%. In some
        cases, limited availability can result in higher prices, while other flights may have competitive fares
        depending on demand and remaining inventory.
      </p>
      <p>
        Use our search engine to compare the Business Class options available for your dates and destination. Midweek
        departures are often about 12% cheaper than weekends. You can review different airlines, departure times,
        connections and fares before choosing the itinerary that suits you.
      </p>
      <p>
        Whether you are travelling unexpectedly for work or have decided on a spontaneous getaway, searching and
        comparing multiple Business Class flights can help you find the most suitable available option. Flexible
        travel dates can also uncover business class deals that save travellers roughly 20% to 70% in some cases.
        If you are open to alternative routings, consolidator fares can sometimes reduce the price of business class
        tickets by 20% to 50%. For your next trip, a good deal is not just the fare, but the included benefits,
        schedule and overall perks as well.
      </p>
      <h2>
        Compare Business Class Airlines
      </h2>
      <p>
        Choosing a Business Class ticket is about more than the price. The experience can differ significantly between
        airlines, aircraft and routes.
      </p>
      <p>
        Our <a href="/airlines/reviews">airline reviews</a> help you compare what different airlines offer across
        cabins, seats, dining, lounges and onboard services.
      </p>
      <p>
        Popular Business Class carriers include top airlines such as Qatar Airways, Emirates, Singapore Airlines,
        Etihad Airways and turkish airlines. If you are weighing up the best airline for a specific trip, look closely
        at the aircraft and route, since the onboard product can vary widely even within the same carrier.
      </p>
      <p>
        Consider factors such as:
      </p>
      <ul className="list-disc ml-8 mb-2">
        <li> Business Class seat configuration </li>
        <li> Lie-flat seat availability </li>
        <li> Direct aisle access </li>
        <li> Privacy </li>
        <li> Onboard dining </li>
        <li> Wi-Fi </li>
        <li> Airport lounge access </li>
        <li> Baggage allowance </li>
        <li> Priority airport services </li>
        <li> Personalized service </li>
        <li> Great service </li>
      </ul>
      <p>
        Use those points to find the most suitable option for this journey, then apply the same comparison approach
        when planning your next trip.
      </p>
      <h2>
        What Do You Get With a Business Class Ticket?
      </h2>
      <p>
        The benefits included with a Business Class ticket depend on the airline, route, aircraft and fare type.
        However, Business Class generally provides a more premium experience than Economy Class for business class
        passengers.
      </p>
      <p>
        Depending on your flight, your Business Class fare may include:
      </p>
      <ul className="list-disc ml-8 mb-2">
        <li> A larger and more comfortable seat </li>
        <li> Lie-flat seating on many long-haul flights </li>
        <li> Priority check-in </li>
        <li> Priority boarding </li>
        <li> Additional checked baggage </li>
        <li> Complimentary lounge access </li>
        <li> Premium food and drinks </li>
        <li> Amenity kits </li>
        <li> In-flight entertainment </li>
        <li> Wi-Fi on selected aircraft </li>
        <li> Priority baggage handling </li>
        <li> A carry-on bag plus a personal item </li>
        <li> Seat selection and other perks </li>
      </ul>
      <p>
        For long-haul flights, the ability to sleep in a lie-flat Business Class seat can be one of the biggest
        advantages, particularly for overnight journeys. Popular Business Class carriers include Qatar Airways,
        Emirates, Singapore Airlines and Turkish Airlines among some of the top airlines for premium travel.
        The best choice often depends on the route, aircraft, and what each airline offers in seating, lounges,
        and service. Singapore Airlines is known for spacious cabins and gourmet dining. Turkish Airlines is known
        for lie-flat seats and flying chefs in Business Class. Many travellers also use frequent flyer miles to
        upgrade when award space is available.
      </p>
      <p>
        Always check the conditions of the specific Business Class fare you are booking because inclusions, great
        service and personalized service can differ between airlines, routes and ticket types.
      </p>
      <h2>
        Best Business Class Lounges in the World
      </h2>
      <p>
        A Business Class journey can begin well before you board the aircraft. Many airlines provide dedicated
        airport lounges where eligible passengers can relax before their flight.
      </p>
      <p>
        Our guide to the best <a href="/airlines/toplists/best-business-class-lounges-in-the-world">Business Class
        lounges in the world</a> explores some of the most impressive premium
        lounges available to Business Class travellers.
      </p>
      <p>
        Depending on the airline and airport, Business Class lounge facilities can include comfortable seating,
        dining areas, showers, Wi-Fi, workspaces, bars and private relaxation areas.
      </p>
      <p>
        Some renowned examples include the Emirates Business Class Lounge, Qatar Airways Al Mourjan Business
        Lounge and Singapore Airlines SilverKris Lounge.
      </p>
      <h2>
        What Are the Best Business Class Seats for Couples and Families?
      </h2>
      <p>
        Travelling together can make choosing the right Business Class seat particularly important. Some aircraft
        feature layouts that provide greater privacy for individual travellers, while others have seating arrangements
        designed to make it easier for couples or families to sit together.
      </p>
      <p>
        Luxury travel is not only about the seat onboard; it also requires reviewing the ground experience and lounge
        access at the departure airport.
      </p>
      <p>
        Our guide to <a href="/airlines/articles/best-business-class-seats-for-couples-and-families"> Business Class
        seats for couples and families </a> explores some of the cabin configurations worth considering.
      </p>
      <p>
        Qatar Airways Qsuite, for example, is known for its flexible seating configuration and privacy doors, while
        airlines such as Emirates and Etihad offer distinctive Business Class cabins on selected aircraft. On some
        routes, you may also find suite style seating or lie flat suites, depending on the aircraft.
      </p>
      <p>
        Before selecting your seat, check the aircraft operating your specific flight. Airlines can use different
        aircraft configurations on the same route, meaning the Business Class experience may change from one
        flight to another.
      </p>
      <h2>
        Business Class vs First Class
      </h2>
      <p>
        Not sure whether to book Business Class or First Class? The differences can extend beyond the price of
        the ticket.
      </p>
      <p>
        Our guide to <a href="/airlines/articles/business-class-vs-first-class"> Business Class vs First Class </a>
        explains the main differences between the two premium cabins. Some newer Business Class cabins also use
        suite-style seating with privacy doors.
      </p>
      <p>
        Business Class typically offers a significant upgrade over Economy Class, with more spacious seating,
        premium meals, priority airport services and, on many long-haul flights, lie-flat beds.
      </p>
      <p>
        First Class can provide an even more exclusive experience on airlines that operate a true international
        First Class cabin. Depending on the carrier and aircraft, First Class may include private suites, more
        personalised service, gourmet meals and additional airport services.
      </p>
      <p>
        The best option depends on your route, budget and the type of experience you want from your journey. It is
        also important to compare the specific aircraft and cabin rather than relying solely on the name of the
        travel class, as lie-flat suites may only be available on selected aircraft or routes.
      </p>
      <h2>
        Can Children Fly in Business Class?
      </h2>
      <p>
        Yes. Children can generally travel in Business Class, although airline rules and requirements can differ
        depending on the child&apos;s age, destination and whether they are travelling with an adult.
      </p>
      <p>
        If you are planning a family trip, check the airline&apos;s rules before purchasing your Business Class tickets.
        Requirements may apply to infants, young children and unaccompanied minors, and fares can vary according to
        age and itinerary.
      </p>
      <p>
        Our guide to <a href="/airlines/toplists/travelling-with-kids-in-business-class"> travelling with children
        in Business Class </a> provides more information to consider when planning a premium-cabin family trip.
      </p>
      <h2>
        How to Find Cheaper Business Class Flights
      </h2>
      <p>
        Business Class fares can vary substantially, so comparing multiple options is an important part of finding
        a competitive ticket price.
      </p>
      <p>
        Here are several ways to potentially reduce the cost of your Business Class flight:
      </p>
      <h3>
        Be Flexible With Your Travel Dates
      </h3>
      <p>
        Business Class fares can change depending on demand and availability. If your schedule allows, search
        several departure and return dates to compare prices.
      </p>
      <h3>
        Compare Different Airlines
      </h3>
      <p>
        One airline may offer a considerably different fare from another for the same destination, especially
        on popular routes served by carriers such as american airlines, british airways, united airlines, and air
        canada. Comparing airlines can help you identify additional options and compare dates, and midweek
        departures can be 10–15% cheaper than weekends.
      </p>
      <h3>
        Check Alternative Airports
      </h3>
      <p>
        Depending on your destination, nearby airports may offer different Business Class fares and flight schedules.
        Consider comparing more than one departure or arrival airport where practical, especially around major hubs
        such as San Francisco. Comparing airlines can help you identify additional options, as coverage on popular
        routes varies by carrier. United Airlines offers direct Business Class flights from 10 US cities. Delta
        provides direct Business Class flights from 18 cities. It can also be worth comparing American Airlines
        on some transatlantic services, while British Airways and Air Canada may open up other major international
        route options.
      </p>
      <h3>
        Consider Connecting Flights
      </h3>
      <p>
        Nonstop Business Class flights are often attractive because they save time, but connecting itineraries
        can sometimes have different fares, especially on longer routes. Compare both options before booking,
        and if nearby airports are an option, check alternative hubs such as San Francisco when weighing departure
        or arrival choices.
      </p>
      <h3>
        Search for Business Class Deals
      </h3>
      <p>
        Special fares and promotional offers can appear throughout the year. Regularly comparing available
        Business Class tickets can help you identify competitive prices when they become available.
      </p>
      <h2>
        Why Book Business Class?
      </h2>
      <p>
        For many travellers, the biggest advantage of Business Class is the additional comfort it provides
        throughout the journey.
      </p>
      <p>
        Instead of simply upgrading the seat, Business Class can improve several parts of the travel experience — from
        the airport lounge and priority services to the onboard seat, dining and sleeping arrangements.
      </p>
      <p>
        For long-haul travel, a Business Class ticket can be particularly appealing because many international
        Business Class cabins feature seats that convert into fully flat beds. Arriving at your destination better
        rested can be especially valuable when travelling for business or when you have a busy itinerary waiting.
      </p>
      <h2>
        Find Your Business Class Flight
      </h2>
      <p>
        Ready to upgrade your next journey? Search and compare Business Class flights and Business Class tickets
        with <a href="/">First-Class.com</a>.
      </p>
      <p>
        Explore fares from airlines around the world, compare flight schedules and cabin options, and find a
        Business Class itinerary that suits your destination, dates and budget.
      </p>
      <p>
        Whether you are looking for a cheap Business Class flight, a last-minute premium-cabin ticket, a long-haul
        Business Class deal or simply a more comfortable way to travel, <a href="/">First-Class.com</a> makes it
        easier to explore your options.
      </p>
      <p>
        Search for Business Class flights today and discover your next premium travel experience.
      </p>
      {+directionsPage === 0 && +routesPage === 0 && (
        <div className={'mt-4'}>
          <ScrollableContent
            heading={
              'Are There Any Hidden Fees When Booking Business Class Tickets?'
            }
            content={
              <p>
                Transparency is our priority. At First-Class.com, we provide a
                clear breakdown of all costs associated with your Business Class
                ticket. While taxes and fees may vary, any additional charges
                will be communicated before finalising your booking.
              </p>
            }
            style={styles.scrollableContentSub}
          />
          <ScrollableContent
            heading='Can I Earn Frequent Flyer Miles on Business Class Flights?'
            
            content={
              <p>
                Yes, most airlines offer frequent flyer programs for Business
                Class flights. Earn miles for future flights, upgrades, or other
                rewards. Check with your preferred airline for specific loyalty
                program details and benefits.
              </p>
            }
            style={styles.scrollableContentSub}
          />
          <ScrollableContent
            heading='Can I Book Flexible Business Class Tickets on First-Class.com?'
            content={
              <p>
                Yes, First-Class.com offers flexible booking options for{' '}
                Business Class tickets. Enjoy the convenience of booking
                flexible fares, allowing changes or cancellations with varying
                terms and conditions depending on the airline and fare type.
              </p>
            }
            style={styles.scrollableContentSub}
          />
          <ScrollableContent
            heading='Can I cancel my Flight on First-Class.com?'
            content={
              <p>
                Yes, the ability to cancel a flight booked on First-Class.com
                depends on the airline&apos;s cancellation policy and the fare
                type selected. Review the specific terms and conditions
                associated with your booking or contact our customer support for
                assistance.
              </p>
            }
            style={styles.scrollableContentSub}
          />
          <ScrollableContent
            heading='Why Should I Book my Flight with First-Class.com?'
            content={
              <p>
                Booking with First-Class.com guarantees access to exclusive{' '}
                Business Class offers, a user-friendly interface, advanced
                search tools, and a seamless booking experience. Find affordable
                Business Class flights, compare prices and services, and enjoy
                the luxury of premium travel while staying within your budget.
              </p>
            }
            style={styles.scrollableContentSub}
          />
        </div>
      )}
    </div>
  );

  return (
    <>
      <PopularDirections
        popularDirections={popularDirections}
        popularRoutes={popularRoutes}
        routesPage={routesPage}
        directionsPage={directionsPage}
        recommendation={recommendation}
        totalRoutesPages={totalRoutesPages}
        totalDirectionsPages={totalDirectionsPages}
        cabinClass={'business-class'}
        topImage={'/images/business-class.jpg'}
        authCompleted={authCompleted}
        seoHTML={seoHtml}
      />
    </>
  );
}

export default withLayout(Flights, false);
